import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4e403870")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, "Живите где угодно", -1)
const _hoisted_2 = { class: "img-cards" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", null, "Чем заняться", -1)
const _hoisted_4 = { class: "img-cards" }
_popScopeId()

import { ImageCard, BigCard } from "@/components";
import { IImageCard } from "@/models/ImageCard";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const imageCards: IImageCard[] = [
  {
    title: "Жилье на природе",
    imageUrl:
      "https://a0.muscache.com/im/pictures/2f13349d-879d-43c6-83e3-8e5679291d53.jpg?im_w=720",
  },
  {
    title: "Уникальное жилье",
    imageUrl:
      "https://a0.muscache.com/im/pictures/36f53e61-db8d-403c-9122-5b761c0e4264.jpg?im_w=720",
  },
  {
    title: "Жилье целиком",
    imageUrl:
      "https://a0.muscache.com/im/pictures/7d82ca14-56e5-4465-8218-dcfa7d69b6ac.jpg?im_w=720",
  },
  {
    title: "Можно с животными",
    imageUrl:
      "https://a0.muscache.com/im/pictures/10a638e1-6aff-4313-8033-1275cec83987.jpg?im_w=720",
  },
];

const imageCardsWithSubTitle: IImageCard[] = [
  {
    title: "Впечатления",
    subtitle: "Найдите интересные мероприятия поблизости.",
    imageUrl:
      "https://a0.muscache.com/im/pictures/ad109d56-2421-40cd-98e6-e114160dc85b.jpg?im_w=720",
  },
  {
    title: "Онлайн-Впечатления",
    subtitle: "Интерактивные мероприятия от опытных организаторов.",
    imageUrl:
      "https://a0.muscache.com/im/pictures/0ce799cb-7553-4369-be9e-d0011e0ef636.jpg?im_w=720",
  },
  {
    title: "Популярная коллекция: тяга к путешествиям",
    subtitle: "Изучайте мир из дома с онлайн-Впечатлениями.",
    imageUrl:
      "https://a0.muscache.com/im/pictures/247a1ea3-946d-4eb8-a6ab-e8b9a66846f4.jpg?im_w=720",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", null, [
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imageCards, (card) => {
          return _createElementVNode("li", {
            key: card.title
          }, [
            _createVNode(_unref(ImageCard), {
              title: card.title,
              img: card.imageUrl
            }, null, 8, ["title", "img"])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("section", null, [
      _createVNode(_unref(BigCard))
    ]),
    _createElementVNode("section", null, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imageCardsWithSubTitle, (card) => {
          return _createElementVNode("li", {
            key: card.title
          }, [
            _createVNode(_unref(ImageCard), {
              title: card.title,
              subtitle: card.subtitle,
              img: card.imageUrl
            }, null, 8, ["title", "subtitle", "img"])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})